import React from 'react';
import "../camera.style.scss";
export const CameraContainer = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "media-camera-container"
  }, children);
};